import React from 'react';
import { Flex } from 'antd';

import { ChatListContainer } from 'features/analytics/features/ChatList/containers/ChatListContainer';

import { useAppSelector } from '../../../../store';
import { MessagesChart } from '../AnalyticMessages/components/MessagesChart';
import { MessageTopicsChart } from '../AnalyticMessages/components/MessageTopicsChart';
import { FinanceChart } from '../AnalyticFinance/components/FinanceChart';
import { ModerationChart } from '../AnalyticModeration/components/ModerationChart';
import { selectAnalyticsFilters } from '../../store/analyticFiltersSlice';
import { getCurrentPageSlug } from '../AnalyticsFilters/utils/filters';
import { ActiveMembersChart } from '../AnalyticMembers/components/ActiveMembersChart';
import { MessagesMultiLineChart } from '../AnalyticMessages/components/MessagesMultiLineChart';
import { PAGE_TYPE } from '../../components/TabSwitcher/service/tabs.interface';
import { MembersMultiLineChart } from '../AnalyticMembers/components/MembersMultiLineChart';

export const AnalyticsAll = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    return (
        <Flex gap={16} vertical>
            {getCurrentPageSlug(filters) === PAGE_TYPE.MANAGE ? (
                <Flex gap={16} justify={'space-between'} wrap={'wrap'}>
                    <MessagesChart />
                    {filters.chat && <MessageTopicsChart />}
                    <FinanceChart />
                    <ModerationChart />
                </Flex>
            ) : (
                <>
                    <Flex gap={16}>
                        <MembersMultiLineChart />
                        <ActiveMembersChart />
                    </Flex>

                    <Flex gap={16}>
                        <MessagesMultiLineChart />
                        <MessagesChart />
                    </Flex>
                </>
            )}

            {!filters.chat && <ChatListContainer />}
        </Flex>
    );
};
